import { NavigationMockApi } from '@sprint-backoffice/app/mock-api/common/navigation/api';
import { IconsMockApi } from '@sprint-backoffice/app/mock-api/ui/icons/api';

export const mockApiServices = [IconsMockApi, NavigationMockApi];
